import { render } from "./MintSuccessModal.vue?vue&type=template&id=ef8943da&scoped=true&ts=true"
import script from "./MintSuccessModal.vue?vue&type=script&lang=ts"
export * from "./MintSuccessModal.vue?vue&type=script&lang=ts"

import "./MintSuccessModal.vue?vue&type=style&index=0&id=ef8943da&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8943da"]])

export default __exports__